import { render, staticRenderFns } from "./gc-popup-copy-bom.vue?vue&type=template&id=67832bff"
import script from "./gc-popup-copy-bom.vue?vue&type=script&lang=js"
export * from "./gc-popup-copy-bom.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-copy-bom.vue?vue&type=style&index=0&id=67832bff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports